export const MESSAGE_TYPES = {
  TEXT: 'text',
  TOOL_CALL: 'tool_call',
  TOOL_RESULT: 'tool_result',
  CARD: 'card',
  BUTTONS: 'buttons',
  FORM: 'form',
  PRODUCT_CARDS: 'product_cards',
  ORDER_CARDS: 'order_cards',
  CITATION: 'citation',
  THINKING: 'thinking',
} as const;
